export default __webpack_public_path__ + "static/media/SEMILLAMAIZ.4dbbdcad.jpg";